var exports = {
  "nM": "x804f0401--c3d179--row",
  "DD": "x804f0401--c3d179--title",
  "mw": "x804f0401--c3d179--required",
};

module.exports = exports;
